export async function transcribeBlob(blob, { signal } = {}) {
  const ext = blob.type.includes('mp4') ? '.mp4' : '.webm'
  const formData = new FormData()
  formData.append(
    'audio',
    new File([blob], `dictation${ext}`, { type: blob.type })
  )

  let response
  try {
    response = await fetch('/voice_transcription/transcribe', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token':
          document.querySelector('meta[name="csrf-token"]')?.content ?? '',
      },
      credentials: 'same-origin',
      body: formData,
      signal,
    })
  } catch (error) {
    // Tag network / abort failures so callers can decide to retry silently
    // (e.g. after the phone unlocks) instead of showing a hard failure.
    if (error && typeof error === 'object') {
      error.recoverable = true
    }
    throw error
  }

  let data = {}
  try {
    data = await response.json()
  } catch {
    // Non-JSON body (proxy HTML, empty) — still surface a useful error.
  }

  if (!response.ok || data.error) {
    const error = new Error(
      data.error || `Transcription failed (${response.status})`
    )
    error.status = response.status
    error.recoverable =
      response.status === 408 ||
      response.status === 429 ||
      response.status === 422 ||
      (response.status >= 500 && response.status <= 599)
    throw error
  }
  // `text` is the cleaned-up transcript that goes in the composer;
  // `raw_text` is the original transcription, kept so the formatting stays reversible.
  return { text: data.text, raw_text: data.raw_text, model: data.model }
}
